import { useLocation } from "react-router-dom";

const MAP = { customers: "customer_id", projects: "project_id", estimates: "estimate_id", contracts: "contract_id" };

export function useAiCtx(extra = {}) {
  const { pathname } = useLocation();
  const [, seg, id] = pathname.split("/");
  const base = MAP[seg] && id && id !== "new" ? { [MAP[seg]]: id } : {};
  return { ...base, ...Object.fromEntries(Object.entries(extra).filter(([, v]) => v)) };
}
